import { FormControl, FormGroup } from '@angular/forms';

export class ProposalLineItemForm extends FormGroup<{
  id: FormControl<undefined | number>;
  ProposalId: FormControl<number | undefined>;
  ProposalRequestLineItemId: FormControl<number | undefined>;
  text: FormControl<string>;
}> {
  constructor() {
    super({
      id: new FormControl<number | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),
      ProposalId: new FormControl<number | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),
      ProposalRequestLineItemId: new FormControl<number | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),
      text: new FormControl<string>('', { nonNullable: true })
    });
  }
}
